import styles from './styles.less';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';


@observer
class ExpiredSlate extends React.Component {
    static propTypes = {
        onCountdown: React.PropTypes.func,
        seconds: React.PropTypes.number.isRequired,
        video: React.PropTypes.object.isRequired
    };

    static defaultProps = {
        seconds: 5
    };

    @observable countdown = 5;

    constructor(props) {
        super(props);
        this.setCountdown(props.seconds);
    }

    componentDidMount() {
        if (this.props.video.expired) {
            this.runCountdown();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.video !== prevProps.video && this.props.video.expired) {
            this.runCountdown();
        }
    }

    componentWillUnmount() {
        this.stopCountdown();
    }

    render() {
        if (!this.props.video.expired) {
            return null;
        }
        const className = cx(styles.root, this.props.className);
        return (
            <div className={ className }>
                <span className={ styles.message }>
                    Sorry.
                </span>
                <span className={ styles.message }>
                    It looks like { this.props.video.title } is no longer available
                </span>
                <span className={ styles.countdown }>
                    Rolling to next available video in { this.countdown }
                </span>
            </div>
        );
    }

    runCountdown() {
        this.stopCountdown();
        this.setCountdown(this.props.seconds);
        this.countdownInterval = window.setInterval(() => {
            const countdown = this.countdown - 1;
            if (countdown < 1) {
                this.stopCountdown();
                this.props.onCountdown && this.props.onCountdown();
            }
            this.setCountdown(countdown);
        }, 1000);
    }

    stopCountdown() {
        window.clearInterval(this.countdownInterval);
        this.countdownInterval = null;
    }

    @action setCountdown = (int) => {
        this.countdown = parseInt(int, 10) || 0;
    };
}


export default ExpiredSlate;



/** WEBPACK FOOTER **
 ** ./src/common/components/expired-slate/index.js
 **/